module.exports = __webpack_public_path__ + "media/point-2.1acb081c.mp3";